import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=a68fe222&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=a68fe222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68fe222",
  null
  
)

export default component.exports